// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3IjOL","insightsList":"newBusinessInsightsMenu_insightsList__3HkWp","active":"newBusinessInsightsMenu_active__1rbB4"};